module.exports = {"pageTitleText":"Scroll管理","createText":"创建规则","groupName":"群组","scrollName":"Scroll名称","status":"状态","sections":{"essential":"基础"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/scrolls.json
// module id = M7kL
// module chunks = 3